<div class="collapse-wrapper" [ngClass]="'headerLayout-' + headerLayout()">
    @if (!isLayout12()) {
    <div class="title-section" (click)="selectSubCategory$.emit(sub_category()?.id); $event.stopPropagation(); $event.preventDefault()">
        <a (click)="hideMenu$.emit(true); $event.stopPropagation()" class="mobile-sub-menu dynamic-desktop-hamburger-panel-text-color border-style" [routerLink]="'category/' + sub_category()?.url_path"><label>{{ sub_category()?.name }} </label></a>
        <img [ngClass]="!isCollapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon" />
    </div>
    }

    @if (isLayout12()) {
    <div class="title-section layout-12-specific" (click)="selectSubCategory$.emit(sub_category()?.id); $event.stopPropagation(); $event.preventDefault()">
        <div class="menu-item-content menu-item-main-container">
            <div class="menu-item-image-text-wrapper menu-item-image-anchor-container">
                <div class="combine-wrapper border-style">
                    <div class="menu-icon menu-item-image-container">
                        <img [id]="sub_category()?.id" [src]="sub_category()?.category_images?.[0] || IMAGE_URLS.productEmptyState" class="category-image menu-item-category-image" />
                    </div>

                    <a (click)="hideMenu$.emit(true); $event.stopPropagation()" class="mobile-sub-menu mobile-category-menu static-header layout-12-menu dynamic-desktop-hamburger-panel-text-color" [id]="sub_category()?.id" [routerLink]="'category/' + sub_category()?.url_path">
                        {{ sub_category()?.name }}
                    </a>
                </div>
            </div>
            <img (click)="selectSubCategory$.emit(sub_category()?.id); $event.stopPropagation()" [ngClass]="!isCollapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon header-menu-collapse" />
        </div>
    </div>
    }

    <div [@collapse]="isCollapsed().toString()">
        <ng-content></ng-content>
    </div>
</div>